export const getServiceWorkerRegistration = async (): Promise<ServiceWorkerRegistration | undefined> => {
    if (!navigator.serviceWorker) {
        console.warn('Service worker is not available');
        return undefined;
    }

    return navigator.serviceWorker.ready;
};
